/* Collection poêles : choix de variante, set au choix (même logique que le bloc « Set au choix » des fiches produit :
   paliers −10/−15/−20 %, pièces ajoutées au panier puis code promo du palier posé par cart/update.js) et ajout au panier.
   Ajout par routes.cart_add_url avec les sections du tiroir, puis événement cart:update du thème (contrat de product-form.js). */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    function build(th, dec, noDec) { var raw = noDec ? String(Math.round(cents / 100)) : value; var p = raw.split('.'); var w = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.length > 1 ? w + dec + p[1] : w; }
    return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return build(',', '.', true);
      if (k === 'amount_with_comma_separator') return build('.', ',', false);
      if (k === 'amount_no_decimals_with_comma_separator') return build('.', ',', true);
      if (k === 'amount_with_apostrophe_separator') return build("'", '.', false);
      return build(',', '.', false);
    });
  }
  function picks(form) { return [].slice.call(form.querySelectorAll('.foc-set-item.est-on')); }
  function qte(el) { return Math.max(0, parseInt(el.dataset.qte || '0', 10) || 0); }
  function setQte(it, n) {
    n = Math.max(0, Math.min(it.dataset.multi ? 9 : 1, n)); it.dataset.qte = String(n); it.classList.toggle('est-on', n > 0);
    var b = it.querySelector('.foc-set-main'); if (b) b.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
    var q = it.querySelector('.foc-qte--set'); if (q) { q.hidden = n === 0; q.querySelector('[data-role=sq]').textContent = String(n); }
  }
  function qteMain() { return 1; }
  function setQteMain() {}
  function pct(set, count) { var t = [0, 0, +set.dataset.p2 || 0, +set.dataset.p3 || 0, +set.dataset.p4 || 0], best = 0; for (var c = 2; c <= Math.min(count, 4); c++) if (t[c] > best) best = t[c]; return best; }
  function codeFor(set, count) { var l = [set.dataset.c2, set.dataset.c3, set.dataset.c4]; var code = ''; for (var c = 2; c <= Math.min(count, 4); c++) if (l[c - 2]) code = l[c - 2]; return code; }
  function majCarte(form) {
    var r = form.querySelector('input[type=radio]:checked'); var hid = form.querySelector('[name=id]');
    var base = r ? +r.dataset.cents : +(form.dataset.cents || 0);
    if (r) {
      hid.value = r.value;
      var prix = form.querySelector('[data-role=prix]'), barre = form.querySelector('[data-role=barre]');
      if (prix) prix.textContent = r.dataset.prix;
      if (barre) { barre.textContent = r.dataset.barre || ''; barre.hidden = !r.dataset.barre; }
    }
    var btn = form.querySelector('.foc-ajouter'); var dispo = r ? r.dataset.dispo === 'true' : !btn.disabled;
    btn.disabled = !dispo; btn.classList.remove('est-ajoute');
    btn.querySelector('span').textContent = dispo ? btn.dataset.ajouter : btn.dataset.rupture;
    // set au choix
    var set = form.querySelector('.foc-set'); var tot0 = form.querySelector('[data-role=btn-total]');
    if (!set) { if (tot0) tot0.hidden = true; return; }
    var on = picks(form), qm = qteMain(form), count = qm, fmt = set.dataset.format;
    on.forEach(function (it) { count += qte(it); });
    var p = pct(set, count), pn = pct(set, count + 1);
    var full = base * qm, total = Math.round(base * qm * (100 - p) / 100);
    [].slice.call(set.querySelectorAll('.foc-set-item')).forEach(function (it) {
      var f = +it.dataset.full, est = it.classList.contains('est-on'), use = est ? p : pn, red = Math.round(f * (100 - use) / 100), n = qte(it);
      it.querySelector('[data-role=sp]').textContent = money(red, fmt); it.querySelector('[data-role=ss]').hidden = !(use > 0);
      if (est) { full += f * n; total += red * n; }
    });
    set.classList.toggle('a-picks', count > 1 && p > 0);
    var pill = set.querySelector('[data-role=pill]'); if (pill) { if (!pill.dataset.base) pill.dataset.base = pill.textContent; pill.textContent = (count > 1 && p > 0) ? (set.dataset.pillOn || '−{pct} %').replace('{pct}', p) : pill.dataset.base; }
    [].slice.call(set.querySelectorAll('[data-palier]')).forEach(function (s) { s.classList.toggle('atteint', count >= +s.dataset.palier); });
    // prix de la variante au-dessus ; total du set dans le bouton (comme la fiche produit)
    var tot = form.querySelector('[data-role=btn-total]');
    if (tot) { tot.querySelector('[data-role=bt-total]').textContent = money(total, fmt); var fu = tot.querySelector('[data-role=bt-full]'); fu.textContent = money(full, fmt); fu.hidden = !(full > total); }
  }
  function sectionsPanier() { var ids = []; document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); }); return ids.join(','); }
  function appliquerCode(code) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
      .then(function (cart) {
        var keep = []; (cart.discount_codes || []).forEach(function (d) { if (d && d.code && d.code.toUpperCase() !== code.toUpperCase()) keep.push(d.code); });
        keep.push(code);
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
      }).then(function (r) { if (!r.ok) throw new Error('code'); });
  }
  function ajouter(form, ev) {
    ev.preventDefault();
    var btn = form.querySelector('.foc-ajouter'); if (!btn || btn.disabled) return;
    var err = form.querySelector('.foc-erreur:not([data-role])') || form.querySelector('.foc-erreur'); err.hidden = true;
    var set = form.querySelector('.foc-set'); var setErr = set && set.querySelector('[data-role=set-err]'); if (setErr) setErr.hidden = true;
    var on = set ? picks(form) : []; var count = qteMain(form); on.forEach(function (it) { count += qte(it); });
    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || root + 'cart/add.js';
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var pre = Promise.resolve();
    if (on.length) {
      pre = fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: on.map(function (it) { return { id: +it.dataset.id, quantity: qte(it) }; }) }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); });
    }
    pre.then(function () {
      var fd = new FormData(form); var secs = sectionsPanier(); if (secs) fd.append('sections', secs); fd.append('sections_url', window.location.pathname);
      return fetch(url, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
    }).then(function (j) {
        if (j.status) { err.textContent = j.description || j.message || 'Erreur'; err.hidden = false; return; }
        var code = on.length && set ? codeFor(set, count) : '';
        if (!code) return j;
        // le code du palier exige les pièces ET l'article principal dans le panier : on le pose après l'ajout, puis on relit le tiroir
        return appliquerCode(code).then(function () {
          var secs = sectionsPanier(); if (!secs) return j;
          return fetch(root + '?sections=' + encodeURIComponent(secs), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (s) { j.sections = s; return j; }).catch(function () { return j; });
        }, function () { if (setErr) { setErr.textContent = (set.dataset.errCode || 'Code {code}').replace('{code}', code); setErr.hidden = false; } return j; });
      }).then(function (j) {
        if (!j || j.status) return;
        var e = new Event('cart:update', { bubbles: true });
        e.detail = { resource: j, sourceId: form.id || 'foc', data: { source: 'product-form-component', itemCount: count, productId: form.dataset.productId, variantId: form.querySelector('[name=id]').value, sections: j.sections || {} } };
        document.dispatchEvent(e);
        on.forEach(function (it) { setQte(it, 0); }); setQteMain(form, 1); majCarte(form);
        btn.classList.add('est-ajoute'); btn.querySelector('span').textContent = btn.dataset.ajoute;
        setTimeout(function () { btn.classList.remove('est-ajoute'); btn.querySelector('span').textContent = btn.dataset.ajouter; }, 2500);
      })
      .catch(function () { err.textContent = 'Erreur réseau'; err.hidden = false; })
      .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  }
  function init() {
    document.querySelectorAll('.foc-form').forEach(function (form) {
      if (form.dataset.focPret) return; form.dataset.focPret = '1';
      form.addEventListener('change', function (e) { if (e.target.type === 'radio') majCarte(form); });
      form.addEventListener('click', function (e) {
        var d = e.target.closest('[data-qte-delta]'); var it = e.target.closest('.foc-set-item');
        if (d && it) { setQte(it, qte(it) + (+d.dataset.qteDelta)); majCarte(form); return; }
        if (it && e.target.closest('.foc-set-main')) { setQte(it, it.classList.contains('est-on') ? 0 : 1); majCarte(form); }
      });
      form.addEventListener('submit', function (e) { ajouter(form, e); });
      majCarte(form);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
